import decimalInput from './index.vue';

export default decimalInput;
